export const data = [
  {
    step: 1,
    // Reframed from "You're one step away from Complete Access" / "Fill in your
    // details to continue."
    //
    // The old copy asked for data and gave nothing back for it. This asks the
    // same three fields as a DELIVERY question — the visitor has already
    // decided to buy, so the useful frame is "where does it go", not "fill in
    // this form". The subline kills the two objections that stall people at a
    // form: how long is this, and what happens to my number.
    title: "Where should we send your access?",
    info: "Three quick fields and you're through to payment. We use these to set up your account and send your login — nothing else.",
  },
  {
    step: 2,
    title: "Complete Your Payment",
    info: "Choose your plan & transfer the amount to the bank account below. Money back guarantee if it's not for you.",
  },
  {
    step: 3,
    title: "Verify Your Payment",
    info: "Almost there! Enter the verification code we sent to your mobile number.",
  },
  {
    step: 4,
    title: "Approve Your Transaction",
    info: "Complete the approval in your Easypaisa app. Check your notifications or go to My Approvals in the app.\n\nNote: Please approve within 30 seconds.",
    img: "/checkout/images/easypaisa-approval.jpeg",
  },
];
